import { useState } from 'react';
import type { UserRole } from '@/types/auth';

export type NewMemberData = {
  first_name: string;
  last_name: string;
  ig_username: string;
  personal_ig_username: string;
  email: string;
  phone_prefix: string;
  phone_number: string;
  country: string;
  city: string;
  birthdate: string;
  usdc_wallet: string;
  password: string;
  password_confirm: string;
  role: UserRole;
};

export type NewMemberFieldErrors = Partial<Record<keyof NewMemberData, string>>;

const EMPTY: NewMemberData = {
  first_name: '',
  last_name: '',
  ig_username: '',
  personal_ig_username: '',
  email: '',
  phone_prefix: '',
  phone_number: '',
  country: '',
  city: '',
  birthdate: '',
  usdc_wallet: '',
  password: '',
  password_confirm: '',
  role: 'collector',
};

export type NewMemberFormState = {
  data: NewMemberData;
  setData: (d: NewMemberData) => void;
  fieldErrors: NewMemberFieldErrors;
  setFieldErrors: (f: NewMemberFieldErrors) => void;
  error: string;
  setError: (m: string) => void;
  photo: globalThis.File | null;
  setPhoto: (f: globalThis.File | null) => void;
  forcedStatus: string;
  setForcedStatus: (s: string) => void;
};

export function useNewMemberForm(): NewMemberFormState {
  const [data, setData] = useState<NewMemberData>(EMPTY);
  const [fieldErrors, setFieldErrors] = useState<NewMemberFieldErrors>({});
  const [error, setError] = useState('');
  const [photo, setPhoto] = useState<globalThis.File | null>(null);
  const [forcedStatus, setForcedStatus] = useState('');
  return {
    data,
    setData,
    fieldErrors,
    setFieldErrors,
    error,
    setError,
    photo,
    setPhoto,
    forcedStatus,
    setForcedStatus,
  };
}
